<div class="sidebar-container">
    <div class="back-button" data-cy="version-version-history-sidebar-back-button" (click)="goBack()">
        {{ 'versions-history.sidebar.button.back' | translate }}
    </div>
    <div class="vessel-info-container">
        <div class="vessel-name">
            {{ vessel.name }}
        </div>
        <div class="history-title">
            {{ 'versions-history.sidebar.title' | translate }}
        </div>
    </div>
    <div
        class="version-info-container"
        *ngFor="let version of versionsList"
        (click)="selectVersion(version)"
        [ngClass]="{ selected: selectedVersion === version }">
        <div class="version-info">
            <ng-container *ngIf="vessel?.projectVersion == version?.name">
                <div class="version-name" data-cy="version-version-history-sidebar-current-version-name">
                    <div>
                        {{ 'versions-history.sidebar.name.prefix' | translate }}
                    </div>
                    <div data-cy="version-version-history-sidebar-current-version-number">
                        {{ version?.name }}
                    </div>
                </div>
                <div class="version-date">
                    <div>
                        {{ 'versions-history.sidebar.name.started' | translate }}
                    </div>
                    <div>
                        {{ formatVersionDate(vessel.versionStartDate) | translate }}
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="vessel?.projectVersion != version?.name">
                <div class="version-name" data-cy="version-version-history-sidebar-old-version-name">
                    <div *ngIf="version?.name !== folderCreated">
                        {{ 'versions-history.sidebar.name.prefix' | translate }}
                    </div>
                    <div *ngIf="version?.name !== folderCreated; else createdTitle">
                        {{ version?.name }}
                    </div>
                    <ng-template #createdTitle>
                        <div>
                            {{ 'versions-history.sidebar.name.folder' | translate }}
                        </div>
                    </ng-template>
                </div>
                <div class="version-date">
                    <div *ngIf="version?.name !== folderCreated">
                        {{ 'versions-history.sidebar.name.published' | translate }}
                    </div>
                    <div>
                        {{ formatVersionDate(version.publishedDate) | translate }}
                    </div>
                </div>
            </ng-container>
        </div>
        <mat-icon
            *ngIf="version?.name !== folderCreated"
            svgIcon="more-options"
            class="icon"
            (click)="openOptions(version.name); $event.stopPropagation()"
            [class.disabled]="projectIsActive()"></mat-icon>

        <ng-container *ngIf="openedOptionVersion === version.name">
            <div style="position: absolute; left: 100px; top: 50px; z-index: 1">
                <div class="option-button" (click)="restoreVersion(version); $event.stopPropagation()" #optionsRef>
                    {{ 'versions-history.sidebar.button.restore' | translate }}
                </div>
            </div>
        </ng-container>
    </div>
</div>
